import { create } from 'zustand';

interface StoreState {
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
}

export const useLinksDetailShow = create<StoreState>((set, get) => {
  return {
    isShow: false,
    setIsShow: (isShow: boolean) => {
      set({ isShow });
    },
  };
});

export const useAddNewFolderShow = create<StoreState>((set, get) => {
  return {
    isShow: false,
    setIsShow: (isShow: boolean) => {
      set({ isShow });
    },
  };
});

export const useInstructionShow = create<StoreState>((set, get) => {
  return {
    isShow: false,
    setIsShow: (isShow: boolean) => {
      set({ isShow });
    },
  };
});

export const useNewUserFlowStartShow = create<StoreState>((set, get) => {
  return {
    isShow: false,
    setIsShow: (isShow: boolean) => {
      set({ isShow });
    },
  };
});
